<template>
  <div class="rechargeRecord">
    <div class="filter-container">
      <span class="transTime">{{ $t('components.date') }}:</span>
      <!-- 提现时间 -->
      <el-date-picker
        v-model="search.times"

        class="mb-10 picker"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd HH:mm:ss"
        :default-time="['00:00:00','23:59:59']"
        type="daterange"
        range-separator="~"
        :start-placeholder="$t('components.start_date')"
        :end-placeholder="$t('components.end_date')"
      />
      <!--交易状态  -->
      <el-select v-model="search.status" class="search-frame status" :placeholder="$t('merchantAccount.po_trans_status')" clearable>
        <el-option
          :key="1"
          :label="$t('map.recharge_status_1')"
          :value="1"
        />
        <el-option
          :key="2"
          :label="$t('map.recharge_status_4')"
          :value="2"
        />
        <el-option
          :key="3"
          :label="$t('map.recharge_status_2')"
          :value="3"
        />
        <el-option
          :key="4"
          :label="$t('map.recharge_status_3')"
          :value="4"
        />
      </el-select>
      <el-button class="search-btn mb-10" type="primary" icon="el-icon-search" @click="getMchRechargeInfo">{{ $t('components.search') }}</el-button>
      <el-button class="mb-10 download-btn" plain type="info" :disabled="downloading" icon="el-icon-download" @click="onClickDowmloadBtn">{{ $t('components.download') }}</el-button>
    </div>
    <div class="tableContainer">
      <!-- 列表 -->
      <el-table
        v-loading="listLoading"
        :data="tableData"
        stripe
        fit
        highlight-current-row
        style="width: 100%"
        class="tableContainer"
      >
        <!-- <el-table-column label="ID" align="center">
          <template slot-scope="scope">
            {{ scope.row.id }}
          </template>
        </el-table-column> -->

        <el-table-column :label="$t('merchantAccount.amount')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.amount | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.bank')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.bank }}</span>
          </template>
        </el-table-column>

        <!-- 资金来源 -->
        <el-table-column :label="$t('merchantAccount.money_source')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.money_source_defined || getFundsSourceMap(scope.row.money_source) }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.bank_account')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.bank_account }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.bank_account_name')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.bank_account_name }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.operator')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.operator ? scope.row.operator :'system' }}</span>
          </template>
        </el-table-column>

        <!-- 交易状态 -->
        <el-table-column :label="$t('merchantAccount.transaction_status')" min-width="150" align="center">
          <template slot-scope="{ row }">
            <div class="status-wrap">
              <el-tag class="tag-custom" :class="[getRechargeStatus(row).class ? getRechargeStatus(row).class : '']" :type="getRechargeStatus(row).type">{{ getRechargeStatus(row).label }}</el-tag>
              <div class="status-tip-wrap">
                <el-tooltip v-if="getRechargeStatus(row).value === 4" placement="top">
                  <div slot="content">
                    <span>{{ row.risk_remark }}</span>
                  </div>
                  <svg-icon icon-class="icon-font-warning" style="color:#F67C7C; position: relative; top: -2px" />
                </el-tooltip>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.create_time')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.create_time }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.update_time')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.update_time }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('components.operation')" align="center" min-width="120">
          <template slot-scope="{ row }">
            <el-button type="primary" plain :disabled="getRechargeStatus(row).value !== 4" @click="reSubmit(row)">{{ $t('components.re_edit') }}</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="onClickPaginator" />
      </div>
      <RechargeModal ref="rechargeModal" />
    </div>

  </div>
</template>

<script>

import { fetchMchRechargeInfo, fetchMchRechargeList } from '@/api/settlement/settlement'
import { rechargeStatusMap, fundsSourceMap } from '@/utils/maps'
import { filterEmptyAttr, exportXlsx } from '@/utils/common'
import { appointDate } from '@/utils/index.js'

export default {
  name: 'Recharge_Record',
  components: {
    Paginator: () => import('@/views/components/Paginator'),
    RechargeModal: () => import('../Modal/RechargeModal.vue')
  },
  data() {
    return {
      search: {
        status: null, // 交易状态
        times: [appointDate(-3) + ' 00:00:00', appointDate() + ' 23:59:59']
      },
      tableData: [],
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      },
      downloading: false
    }
  },
  computed: {
    getRechargeStatus() {
      return function(item) {
        let value
        if (item.risk_status === 1) {
          value = 1
        } else if (item.risk_status === 2) {
          value = 4
        } else if (item.risk_status === 4 && item.payment_status === 1) {
          value = 1
        } else if (item.risk_status === 4 && item.payment_status === 2) {
          value = 2
        } else if (item.risk_status === 4 && item.payment_status === 3) {
          value = 3
        } else if (item.risk_status === 3 && item.payment_status === 1) {
          value = 1
        } else if (item.risk_status === 3 && item.payment_status === 3) {
          value = 3
        }
        const res = rechargeStatusMap(value)
        return { value, ...res }
      }
    },
    getRechargeStatusLabel() {
      return function(value) {
        return rechargeStatusMap(value).label
      }
    },
    getFundsSourceMap() {
      return function(value) {
        return fundsSourceMap(value).label
      }
    }
  },
  created() {
    this.getMchRechargeInfo()
  },
  methods: {
    reSubmit(row) {
      this.$refs.rechargeModal.showModal(row)
    },
    getMchRechargeInfo(otherParams) {
      this.listLoading = true
      const params = this.getParams(otherParams)
      fetchMchRechargeList(params).then(res => {
        const { total, list = [] } = res.data
        this.listQuery.total = total
        this.listQuery.page = params.page ? params.page : 1
        this.tableData = list
      }).finally(() => {
        this.listLoading = false
      })
    },

    getParams(otherParams = {}) {
      const { status, times = [] } = this.search
      let params = { start_date_time: times && times[0], end_date_time: times && times[1], status, ...otherParams }
      params = filterEmptyAttr(params)
      return params
    },

    onClickDowmloadBtn() {
      const params = this.getParams()
      params.page = 0
      this.downloading = true
      fetchMchRechargeList(params).then(res => {
        this.$message.success('Start downloading!')
        this.handleXlsxData(res.data.list).then((downloadData) => {
          exportXlsx(downloadData, 'Recharge_Record')
        })
      }).finally(() => {
        setTimeout(() => {
          this.downloading = false
        }, 3000)
      })
    },

    handleXlsxData(data = []) {
      const rows = [[
        this.$t('merchantAccount.transaction_amount'),
        this.$t('merchantAccount.bank'),
        this.$t('merchantAccount.money_source'),
        this.$t('merchantAccount.bank_account'),
        this.$t('merchantAccount.bank_account_name'),
        this.$t('merchantAccount.operator'),
        this.$t('merchantAccount.transaction_status'),
        this.$t('merchantAccount.create_time'),
        this.$t('merchantAccount.update_time')
      ]]

      const toDivide100 = this.$options.filters['toDivide100']
      if (Array.isArray(data) && data.length > 0) {
        data.forEach((tr) => {
          rows.push([
            toDivide100(tr.amount),
            tr.bank,
            tr.money_source_defined || this.getFundsSourceMap(tr.money_source),
            tr.bank_account,
            tr.bank_account_name,
            tr.operator ? tr.operator : 'system',
            this.getRechargeStatus(tr).label,
            tr.create_time,
            tr.update_time
          ])
        })
      }
      return Promise.resolve(rows)
    },

    onClickPaginator() {
      this.getMchRechargeInfo(this.listQuery)
    }
  }
}
</script>

<style lang="scss" scoped>
.rechargeRecord{
   background-color: #fff;
   .transTime{
    display: inline-block;
    padding: 0 20px 10px 0;
    font-size: 14px;
    font-weight: 500;  font-family: 'Poppins-Medium';
    color: #606266;
  }
  .filter-container{
    margin-top: 14px;
    margin-bottom: 32px;
    text-align: right;
  }
  .search-frame {
    width: 160px;
    margin-right: 5px;
  }
  .search-btn {
    margin-right: 10px;
  }
  .picker{
    margin-right: 5px;
  }
  .status{
    margin-right: 10px;
  }
  .download-btn{
    margin: 0;
  }
 .mb-10{
    margin-bottom: 10px;
  }
}
.status-wrap {
  display: inline-block;
  position:relative;
  .status-tip-wrap {
    position:absolute;
    top:40%;
    transform:translateY(-50%);
    right:-20px;
  }
}
</style>
